import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPin = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.975 2.103a2.175 2.175 0 0 0-2.513.929l-2.902 4.34-6.106 1.36-.014.003a1.605 1.605 0 0 0-.776 2.676l.009.008 3.9 3.907-5.355 5.396a.75.75 0 1 0 1.064 1.056l5.352-5.39 3.803 3.81.028.026a1.62 1.62 0 0 0 2.655-.796l.003-.013 1.44-6.035 4.4-2.839a2.175 2.175 0 0 0 .43-3.36L16.82 2.606l-.017-.016a2.2 2.2 0 0 0-.827-.487m-.754 1.403a.68.68 0 0 1 .547.17l4.555 4.556a.675.675 0 0 1-.148 1.033l-.018.01-4.66 3.008a.75.75 0 0 0-.322.456l-1.509 6.318a.12.12 0 0 1-.14.083.1.1 0 0 1-.047-.021l-8.738-8.753a.105.105 0 0 1 .05-.172l6.388-1.423a.75.75 0 0 0 .46-.315l3.079-4.603.017-.028a.67.67 0 0 1 .486-.319"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPin;
